import { WidgetConfig } from '../../components/elements/Draggable';
import { ApiService } from '../../constants';
import { HttpService } from '../../utilities';

interface GetChart {
  StartDate: string;
  EndDate: string;
}

interface GetMostCourses extends GetChart {
  CategoryId: string;
}

interface GetChartPlan extends GetChart {
  Year?: string;
  Month?: string;
  Bulan?: string;
  Tahun?: string;
  BuName?: string;
  BuCode?: string;
  DeptCode?: string;
  SubBuName?: string;
  SubBuCode?: string;
  DeptName?: string;
  SectionName?: string;
  SectionCode?: string;
  Status?: string;
  CategoryId?: string;
  CourseId?: string;
  Program?: string;
}

interface GetKnowledgeImprovementChart extends GetChart {
  Year: string;
  Month: string;
}

interface GetChartMostFavorite extends GetChart {
  TypeEnrol: string;
  StartDate: string;
  EndDate: string;
}

interface GetListOfCourse extends GetChart {
  Parent: string;
  BuName?: string;
  SubBuName?: string;
  DeptName?: string;
  SectionName?: string;
}

export const getChartPlanCompletion = ({
  StartDate,
  EndDate,
  BuName,
  BuCode,
  Bulan,
  SubBuName,
  SubBuCode,
  DeptName,
  DeptCode,
  SectionName,
  SectionCode,
  Tahun
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.chartPlanCompletionTraining,
    {
      StartDate,
      EndDate,
      BuCode,
      Month: Bulan,
      SubBuCode,
      Year: Tahun,
      DeptCode,
      SectionCode
    }
  );
};

export const getChartCompletionRateProgram = ({
  StartDate,
  EndDate,
  BuName,
  Bulan,
  SubBuName,
  DeptName,
  Tahun,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  Program
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.completionRateProgram,
    {
      StartDate,
      EndDate,
      BuName,
      Month: Bulan,
      SubBuName,
      Year: Tahun,
      DeptName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      Program
    }
  );
};

export const getChartCompletionRateCourse = ({
  StartDate,
  EndDate,
  BuName,
  Bulan,
  SubBuName,
  DeptName,
  Tahun,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  CourseId
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.completionRateCourseFix,
    {
      StartDate,
      EndDate,
      BuName,
      Month: Bulan,
      SubBuName,
      Year: Tahun,
      DeptName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      CourseId
    }
  );
};

export const getListOfCourse = ({
  StartDate,
  EndDate,
  Parent,
  BuName,
  SubBuName,
  DeptName
}: GetListOfCourse) => {
  return HttpService.post(ApiService.icdc.module.dashboardbcld.listOfCourse, {
    StartDate,
    EndDate,
    Parent,
    BuName,
    SubBuName,
    DeptName
  });
};

export const requestDownloadListOfCourse = ({
  StartDate,
  EndDate,
  Parent,
  BuName,
  SubBuName,
  DeptName
}: GetListOfCourse) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.downloadListOfCourse,
    {
      StartDate,
      EndDate,
      Parent
    }
  );
};

export const getMostCompletedCourses = ({
  StartDate,
  EndDate,
  BuName,
  SubBuName,
  DeptName,
  SectionName,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.mostCompletedCourse,
    {
      StartDate,
      EndDate,
      TypeEnroll: 'self',
      BuName,
      SubBuName,
      DeptName,
      SectionName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode
    }
  );
};

export const getMostFavoriteCourses = ({
  StartDate,
  EndDate,
  BuName,
  SubBuName,
  DeptName,
  SectionName,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.mostFavoriteCourse,
    {
      StartDate,
      EndDate,
      BuName,
      SubBuName,
      DeptName,
      TypeEnrol: 'self',
      SectionName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode
    }
  );
};

export const getChartSatisfactoryReport = ({
  StartDate,
  EndDate,
  BuName,
  Bulan,
  SubBuName,
  Tahun,
  DeptName,
  SectionName,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.statifactoryReport,
    {
      StartDate,
      EndDate,
      BuName,
      Month: Bulan,
      SubBuName,
      SectionName,
      Year: Tahun,
      DeptName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode
    }
  );
};

export const getChartLearningEngagement = ({
  StartDate,
  EndDate,
  BuName,
  Bulan,
  SubBuName,
  Tahun,
  SectionName,
  DeptName,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.learningEngagement,
    {
      StartDate,
      EndDate,
      BuName,
      DeptName,
      Month: Bulan,
      SubBuName,
      SectionName,
      Year: Tahun,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode
    }
  );
};

export const getChartCompletionEmployee = ({
  StartDate,
  EndDate,
  BuName,
  Bulan,
  SubBuName,
  Tahun,
  DeptName,
  SectionName,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.completionEmployee,
    {
      StartDate,
      EndDate,
      BuName,
      Month: Bulan,
      SubBuName,
      SectionName,
      Year: Tahun,
      DeptName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode
    }
  );
};

export const getChartKnowledgeImprovement = ({
  StartDate,
  EndDate,
  Month,
  BuName,
  SubBuName,
  DeptName,
  Year,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  SectionName
}) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.knowledgeImprovement,
    {
      StartDate,
      EndDate,
      BuName,
      Month,
      SubBuName,
      Year,
      DeptName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      SectionName
    }
  );
};

export const getDownloadKnowledgeImprovement = ({
  StartDate,
  EndDate,
  Bulan,
  BuName,
  SubBuName,
  DeptName,
  Tahun,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.downloadKnowledgeImprovement,
    {
      StartDate,
      EndDate,
      Month: Bulan,
      // BuName,
      // SubBuName,
      // DeptName,
      Year: Tahun,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode
    }
  );
};

export const getDownloadListOfCourse = ({
  StartDate,
  EndDate,
  Parent
}: GetListOfCourse) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.downloadListOfCourse,
    { StartDate, EndDate, Parent: 'Program' }
  );
};

export const getChartBudgetRealization = ({
  StartDate,
  EndDate,
  BuName,
  Bulan,
  SubBuName,
  Tahun,
  DeptName,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionName,
  SectionCode
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.budgetRealization,
    {
      StartDate,
      EndDate,
      BuName,
      Month: Bulan,
      SubBuName,
      Year: Tahun,
      DeptName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionName,
      SectionCode
    }
  );
};

export const getDownloadBudgetRealization = ({
  StartDate,
  EndDate,
  Bulan,
  BuName,
  SubBuName,
  DeptName,
  Tahun,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  SectionName,
  Year,
  Month
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.downloadBudgetRealization,
    {
      StartDate,
      EndDate,
      Month: Bulan,
      BuName,
      SubBuName,
      DeptName,
      Year: Tahun,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionName,
      SectionCode
    }
  );
};

export const requestDownloadDataChartPlanTraining = ({
  StartDate,
  EndDate,
  BuName,
  Bulan,
  SubBuName,
  Tahun,
  BuCode,
  SubBuCode,
  DeptName,
  DeptCode,
  SectionName,
  SectionCode
}) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.downloadDataChartPlanTraining,
    {
      StartDate,
      EndDate,
      BuName,
      Month: Bulan,
      SubBuName,
      DeptName,
      Year: Tahun,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionName,
      SectionCode
    }
  );
};

export const requestDownloadDataChartRateProgram = ({
  StartDate,
  EndDate,
  BuName,
  Bulan,
  SubBuName,
  Tahun,
  BuCode,
  SubBuCode,
  DeptName,
  DeptCode,
  SectionName,
  SectionCode,
  Program
}) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.downloadDataChartCompletionRateProgram,
    {
      StartDate,
      EndDate,
      BuName,
      Month: Bulan,
      SubBuName,
      DeptName,
      Year: Tahun,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionName,
      SectionCode,
      Program
    }
  );
};

export const requestDownloadDataChartMostCompleted = ({
  StartDate,
  EndDate,
  BuName,
  Bulan,
  SubBuCode,
  SubBuName,
  BuCode,
  Tahun,
  DeptCode,
  SectionCode,
  CourseId
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.downloadDataMostCompletedCourse,
    {
      StartDate,
      EndDate,
      BuName,
      Bulan,
      SubBuName,
      Tahun,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      CourseId
    }
  );
};

export const requestDownloadDataChartCompletionRateCourse = ({
  StartDate,
  EndDate,
  Bulan,
  BuName,
  SubBuName,
  DeptName,
  Tahun,
  BuCode,
  SubBuCode,
  DeptCode,
  SectionCode,
  CourseId
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.downloadDataChartCompletionRate,
    {
      StartDate,
      EndDate,
      BuName,
      Month: Bulan,
      SubBuName,
      Year: Tahun,
      DeptName,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionCode,
      CourseId
    }
  );
};

export const requestDownloadDataChartLearningEngagement = ({
  StartDate,
  EndDate,
  BuName,
  Bulan,
  SubBuName,
  Tahun,
  BuCode,
  SubBuCode,
  DeptName,
  DeptCode,
  SectionName,
  SectionCode
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.downloadDataChartLearningEngagement,
    {
      StartDate,
      EndDate,
      BuName,
      Month: Bulan,
      SubBuName,
      DeptName,
      Year: Tahun,
      BuCode,
      SubBuCode,
      DeptCode,
      SectionName,
      SectionCode
    }
  );
};

export const requestDownloadDataChartEmployee = ({
  StartDate,
  EndDate,
  BuCode,
  BuName,
  DeptCode,
  DeptName,
  SectionCode,
  SectionName,
  SubBuCode,
  SubBuName,
  Tahun,
  Bulan
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.downloadDataChartCompletionEmployee,
    {
      StartDate,
      EndDate,
      BuCode,
      BuName,
      DeptCode,
      DeptName,
      SectionCode,
      SectionName,
      SubBuCode,
      SubBuName,
      Year: Tahun,
      Month: Bulan
    }
  );
};

export const requestDownloadDataChartSatisfactoryReport = ({
  StartDate,
  EndDate,
  BuCode,
  BuName,
  DeptCode,
  DeptName,
  SectionCode,
  SectionName,
  SubBuCode,
  SubBuName,
  Bulan,
  Tahun
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.downloadDataChartSatisfactionReport,
    {
      StartDate,
      EndDate,
      BuCode,
      BuName,
      DeptCode,
      DeptName,
      SectionCode,
      SectionName,
      SubBuCode,
      SubBuName,
      Month: Bulan,
      Year: Tahun
    }
  );
};

export const requestDownloadSatisfaction = ({
  StartDate,
  EndDate
}: GetChartPlan) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.downloadDataChartSatisfactionReport,
    { StartDate, EndDate }
  );
};

export const requestDownloadDataChartMostFavoriteCourse = ({
  StartDate,
  EndDate,
  TypeEnrol
}: GetChartMostFavorite) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.downloadDataChartMostFavoriteCourse,
    { StartDate, EndDate, TypeEnrol }
  );
};

interface PostWidget {
  binusianId: string;
  data: WidgetConfig[];
}

export const postWidgetConfiguration = (data: PostWidget) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.postWidgetConfiguration,
    { binusianID: data.binusianId, data: data.data }
  );
};

export const rstWidgetConfiguration = () => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.rstWidgetConfiguration,
    {}
  );
};

interface ParamsConfig {
  binusianId: string;
}

export const getConfigDashboardBCLD = ({ binusianId }: ParamsConfig) => {
  return HttpService.get(
    `${ApiService.icdc.module.dashboardbcld.dashboardWidgetConfiguration}?binusianId=${binusianId}`
  );
};

export const getSubBusinessUnit = (data) => {
  return HttpService.post(
    ApiService.icdc.module.dashboardbcld.subBusinessUnit,
    { ...data }
  );
};

export const getDepartement = (data) => {
  return HttpService.post(ApiService.icdc.module.dashboardbcld.departement, {
    ...data
  });
};

export const getSection = (data) => {
  return HttpService.post(ApiService.icdc.module.dashboardbcld.section, {
    ...data
  });
};
